import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Wrapper from '../layouts/Wrapper';
import { clearBasket } from '../store/actions/user';

function ThankYou() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams({});
  const [message, setMessage] = useState('');
  const status = searchParams.get('status');
  const dispatch = useDispatch();
  useEffect(() => {
    if (status === 'success') {
      setMessage(t('payment.success'));
      dispatch(clearBasket());
    } else {
      setMessage(t('payment.failed'));
    }
  }, []);

  return (
    <Wrapper>
      <h1 style={{ textAlign: 'center' }}>{message}</h1>
    </Wrapper>
  );
}

export default ThankYou;
